import {CloudDownload} from '@material-ui/icons';
// ==================== Importing whitepaper Doc from the relative path directory ==================
import westream_whitepaper from '../assets/docs/whitepaper.pdf';

// ======================= Whitepaper ==================
const Whitepaper = () => {
    return (
        <section id="whitePaper">
            <div className="container text_center">
                <div className="sec-heading-wrapper">
                    {/* ================== main heading ===================== */}
                    <h1 className="sec-heading" data-aos="fade-down">Whitepaper</h1>
                </div>
                <br />
                {/* ================ body text ==================== */}
                <p className="intro" data-aos="fade-up">
                    Our whitepaper is intended as a technical outline for the WeStream app and should not interpreted as legal advice nor an agreement, contract or solicitation to buy or subscribe to debentures, stocks, cryptocurrency, or shares issued by any persons, company or entity, units in a collective investment scheme, or any other security or class of securities. The WeStream tokens are not securities, are not registered with any government entity as a security and shall not in any case be considered as such.
                </p>
                <br />
                {/* =================== whitepaper download button ================ */}
                <a download href={westream_whitepaper} className="cs_btn">Whitepaper.pdf &nbsp; <CloudDownload className="btn_icon"/></a>
            </div>
        </section>
    );
};

export default Whitepaper;
